<template>
    <div class="header-head">
        <v-container>
            <v-row no-gutters align="center">
                <v-col v-if="this.$slots['default']">
                    <slot />
                </v-col>
                <v-col v-if="this.$slots['left']" cols="auto">
                    <slot name="left" />
                </v-col>
                <v-col v-if="this.$slots['center']">
                    <slot name="center" />
                </v-col>
                <v-spacer v-if="!this.$slots['center'] && this.$slots['right']" />
                <v-col v-if="this.$slots['right']" cols="auto">
                    <slot name="right" />
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
export default {
    props: {},
    components: {},
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.header-head {
    height: var(--header-head-height);
    padding: 12px 0;
    -webkit-transition: all ease-out 0.2s;
    -ms-transition: all ease-out 0.2s;
    transition: all ease-out 0.2s;
}
</style>
